export const FONT_OPTIONS = [
  { value: "", label: "Default (clean sans)" },
  { value: "serif", label: "Serif (elegant)" },
  { value: "display", label: "Display (bold)" },
  { value: "mono", label: "Monospace" },
  { value: "hand", label: "Handwritten" },
];

export const SIZE_OPTIONS = [
  { value: 14, label: "Small" },
  { value: 16, label: "Normal" },
  { value: 19, label: "Large" },
  { value: 24, label: "Extra large" },
];

export function fontFamily(v) {
  switch (v) {
    case "serif": return "'Fraunces', Georgia, serif";
    case "display": return "'Outfit', sans-serif";
    case "mono": return "ui-monospace, 'Courier New', monospace";
    case "hand": return "'Comic Sans MS', 'Segoe Print', cursive";
    default: return "inherit";
  }
}

export function descStyle(e) {
  return {
    fontFamily: fontFamily(e?.font_family),
    fontSize: `${e?.font_size || 16}px`,
    letterSpacing: `${e?.letter_spacing || 0}px`,
    whiteSpace: "pre-wrap",
    lineHeight: 1.7,
  };
}
